// imports shared across all ORA templates
require('../ora/base/imports');

// modules
require('../site_scripts/mtc_finance_video_overlay');
require('../ora-offer/sticky-menu')
require('../ora-offer/move-offer-image')
require('../ora-offer/tabs')
require('../ora-offer/floating-sidebar')

// ORA home page styles
require('../../styles/entry/ora-offers.less')
